module.exports = __webpack_public_path__ + "a37dbd8e5b4fa321da55e74871a4afde.jpg";